import type { WShopAdditionalSearchOptionsTranslations } from "./pl";

export const en: WShopAdditionalSearchOptionsTranslations = {
  title: "Filters",
  emptyContext: "Filters are available only inside a shop category.",
  sections: {
    query: "Search",
    categorys: "Categories",
    producent: "Manufacturer",
    variants: "Features",
    price: "Price",
  },
  activeHeader: "Active filters",
  clearAll: "Clear all",
  removeChip: "Remove filter",
  queryPlaceholder: "Type a phrase...",
  priceFromLabel: "From",
  priceToLabel: "To",
  buttons: {
    apply: "Apply",
    cancel: "Cancel",
  },
  emptyFacet: "No available options.",
  resultsUpdated: "Product list has been updated.",
};
